/**
 * Moderation report types - shared between frontend and backend
 */

export enum ModerationReportContextType {
  CHARACTER_PROFILE = 'character_profile',
  GUILD_PROFILE = 'guild_profile',
  USER_PROFILE = 'user_profile',
  TEAM_PROFILE = 'team_profile',
  RECRUITMENT_LISTING = 'recruitment_listing',
  RECRUITMENT_MESSAGE = 'recruitment_message',
  KEYSTONE_RUN = 'keystone_run',
  RAID_ENCOUNTER = 'raid_encounter',
  OTHER = 'other'
}

export enum ModerationReportStatus {
  PENDING = 'pending',
  UNDER_REVIEW = 'under_review',
  RESOLVED = 'resolved',
  DISMISSED = 'dismissed'
}

export enum ModerationAuditAction {
  STATUS_CHANGE = 'status_change',
  NOTES_UPDATED = 'notes_updated'
}

/** Error codes thrown by moderationReportService.createReport */
export const MODERATION_ERRORS = {
  INVALID_REASON: 'invalid_reason',
  DESCRIPTION_REQUIRED: 'description_required',
  BOT_DETECTED: 'bot_detected',
  REPORTER_BANNED: 'reporter_banned',
  CAPTCHA_REQUIRED: 'captcha_required',
  CAPTCHA_INVALID: 'captcha_invalid'
} as const;
